import React, { Component } from "react";
import CommonTemplate from "./commonTemplate";
import Signbutton from "../forms/button";
import { Input } from "../forms/input";
import { connect } from "react-redux";
import { forgotPassword,validateForgotOtp } from "../../store/actions";
import { CommonOtp } from "./otp";
import { QueryAssistant } from "../home/home";
import CustomLoader from "../forms/Loader";
import { encrypt } from "./login";
class ForgotPassword extends Component {
  constructor(props) {
    super(props);
    this.state = {
      userId: { value: "" },
      count: 1,
      display: false,
    };
  }

  changeValue = (event) => {
    this.setState({
      userId: { value: event.target.value },
    });
  };

  showError = () => {
    const {
      userId: { value },
    } = this.state;
    this.setState({
      userId: {
        value,
        isError: !value,
        errorMessage: "User ID is required to proceed",
      },
    });
  };

  sendOtp = async () => {
    const {
      userId: { value },
    } = this.state;
    if (!value) {
      this.userIdField.focus();
      this.setState({
        userId: {
          value,
          isError: !value,
          errorMessage: "User ID is required to proceed*",
        },
      });
    } else {
      this.regenerteOtp();
    }
  };

  
  
  submitOtp = async (enteredOtp) => {
    try {
      this.setState({
        loading: true
      })
      const { token } = await this.props.validateForgotOtp({
        otp: encrypt(enteredOtp.join("")),
        otpid: encrypt(this.state.otpid),
      });
      if (!token) {
        alert("Please Enter valid OTP");
        this.setState({
          loading: false
        })
        return;
      }

      this.props.history.replace({
        pathname: "/reset-password",
        state: { token },
      });
      this.setState({
        loading: false
      })
    } catch (error) {
      this.setState({
        loading: false
      })
      alert(error || "Please Enter valid OTP");
    }
  };




  regenerteOtp = async () => {
    try {
      const {
        userId: { value },
      } = this.state;
      const params = {
        userid: value,
      };
      this.setState({
        loading: true
      })

      const response = await this.props.forgotPassword(params);
      const { otpid } = response;

      this.setState({
        loading: false,
        otpid,
        textOne:
          "OTP has been sent to your registered Email ID and Mobile Number",
      });
    } catch (error) {
      this.setState({ textOne: error?.message, loading: false });
    }
  };

  keyPress = (e) => {
    if (e.key === "Enter") {
      this.sendOtp();
      e.preventDefault();
    }
  };

  render() {
    const { userId, otp, textOne, textTwo, count, display,otpid } = this.state;
    return (
      <>
        <CustomLoader display={!!this.state.loading} />
        <CommonTemplate
          title="Forgot Password"
          textOne={textOne}
          textTwo={textTwo}
          count={count}
        >
          {/* <QueryAssistant /> */}
          <Input
            maxLength={50}
            name="User ID"
            value={userId.value}
            bordercolor="#a6a6a6"
            onChange={this.changeValue}
            onBlur={this.showError}
            isShowError={userId.isError}
            inputref={(ele) => (this.userIdField = ele)}
            errorMessage={userId.errorMessage}
            disabled={!!otpid}
            onKeyPress={this.keyPress}
          />
          {!otpid ? (
            <Signbutton buttontitle="Submit" onClick={this.sendOtp} />
          ) : (
            <CommonOtp
              submitOtp={this.submitOtp}
              regenerteOtp={this.regenerteOtp}
            />
          )}
        </CommonTemplate>
        <div className="ReturntoSignin">
          <button
            className="login-no-account-span1 mouse-pointer border-0"
            onClick={() => this.props.history.push("/login")}
          >
            Return to signin
          </button>
        </div>
      </>
    );
  }
}

export default connect(null, { forgotPassword ,validateForgotOtp})(ForgotPassword);
